import { Component, computed, input } from '@angular/core';
import { IconVariant } from './icon.types';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.html',
  styleUrl: './icon.scss',
})
export class Icon {
  name = input('warning');
  variant = input<IconVariant>(IconVariant.Regular);
  isCustom = input(false);
  size = input(16);
  color = input<string>();

  protected classes = computed(
    () => `fa-${this.name()} ${this.isCustom() ? 'fak' : 'fa-' + this.variant()}`,
  );

  protected styles = computed(() => {
    const s = this.size();
    const c = this.color();
    return {
      'font-size': `${s}px`,
      width: `${s}px`,
      height: `${s}px`,
      ...(c ? { color: `var(--${c})` } : {}),
    };
  });
}
